import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlphaNumericDirective, alphabetsDirective, numbersDirective, AlphaNumericSpaceDirective, alphabetsSpecialChar, emailPatter, numbersSpacesDirective, DesimalDirective, specialCharectersDirective, ConvertToTitleCasePipe, } from 'src/app/directives/alpha-numeric.directive';
import { AutoFocusDirective, ClickOutsideDirective } from './custom.directive';
import { ToolTipRendererDirectiveDirective } from './tool-tip-renderer-directive.directive';
import { TextFieldCharRestrictDirective } from './text-field-char-restrict.directive';
@NgModule({
  declarations: [
    ClickOutsideDirective,
    AlphaNumericDirective,
    alphabetsDirective,
    numbersDirective,
    alphabetsSpecialChar,
    emailPatter,
    numbersSpacesDirective,
    AlphaNumericSpaceDirective,
    DesimalDirective,
    AutoFocusDirective,
    ToolTipRendererDirectiveDirective,
    specialCharectersDirective,
    ConvertToTitleCasePipe,
    TextFieldCharRestrictDirective
  ],
  imports: [
    CommonModule
  ],
  exports:[
    ClickOutsideDirective,
    AlphaNumericDirective,
    alphabetsDirective,
    numbersDirective,
    alphabetsSpecialChar,
    emailPatter,
    numbersSpacesDirective,
    AlphaNumericSpaceDirective,
    DesimalDirective,
    AutoFocusDirective,
    ToolTipRendererDirectiveDirective,
    specialCharectersDirective,
    ConvertToTitleCasePipe,
    TextFieldCharRestrictDirective
  ]
})
export class CommonDirectivesModule { }
